import { Button, Card, Flex, Icon, Row, Title } from '@wyz/ui';
import { PropsWithChildren, ReactNode } from 'react';
import { Trans } from '~/common/context';
type Props = {
  title: ReactNode;
  onOpenModal: () => void;
};

const ModalTrigger = ({
  title,
  children,
  onOpenModal,
}: PropsWithChildren<Props>) => {
  return (
    <Row className='mt-3'>
      <Card>
        <Card.Body>
          <Flex
            alignItems='center'
            justifyContent='between'
            className='w-100'
            wrap='wrap'
          >
            <Title heading='xl' weight='bold'>
              {title}
            </Title>
            <div className='flex-1 ms-3'>{children}</div>
            <Button
              id='new-search-button'
              variant='primary'
              onClick={onOpenModal}
              className='ms-2'
            >
              <Icon icon='search' size='xs' className='me-2' />
              <Trans i18nKey='app.common.button.new_search' />
            </Button>
          </Flex>
        </Card.Body>
      </Card>
    </Row>
  );
};

export default ModalTrigger;
